export const RNDocumentScanner = {
    scanDocument: async () => {},
  };